import styled from 'styled-components'

export const Text = styled.span`
  color: #696977;
  font-size: 12px;
`
